export const OperatorQueryKeys = {
  all: ["operator"] as const,
  findOpenedIntervention: () => [...OperatorQueryKeys.all, "opened-intervention"] as const,
  findAllOperations: (opened?: boolean) => [...OperatorQueryKeys.all, "operations", opened ?? false] as const,
};
